import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthenticatedLayout from '../../components/layouts/authenticated_layout'
import { useOwnRecruitment } from '../../hooks/use_own_recruitment'
import PartnerRecruitmentCard from '../../components/cards/partner_recruitment_card'
import { useInfiniteScroll } from '../../hooks/use_infinite_scroll'
import LoadingSpinner from '../../components/loading/loading_spinner'
import RadioButtonGroup, {
  RadioButtonType,
} from '../../components/buttons/radio_button_group'
import {
  RecruitmentSortType,
  RecruitmentSortTypeLabel,
} from '../../types/recruitment'
import Breadcrumb from '../../components/common/breadcrumb'

/**
 * 共創パートナー募集一覧ページ
 * 自社のパートナー募集一覧を表示し、作成・編集・詳細表示機能を提供
 */
const RecruitmentPage: React.FC = () => {
  const navigate = useNavigate()
  const {
    isLoading,
    isLoadingMore,
    hasMore,
    recruitments,
    loadMore,
    changeSort,
  } = useOwnRecruitment()

  const { LoadingElement } = useInfiniteScroll(loadMore, isLoadingMore, hasMore)

  const sortButtons: RadioButtonType[] = useMemo(
    () => [
      {
        label: RecruitmentSortTypeLabel[RecruitmentSortType.CREATED_AT],
        onClick: () => changeSort(RecruitmentSortType.CREATED_AT),
      },
      {
        label: RecruitmentSortTypeLabel[RecruitmentSortType.NAME],
        onClick: () => changeSort(RecruitmentSortType.NAME),
      },
    ],
    [changeSort]
  )

  return (
    <AuthenticatedLayout>
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb
          items={[
            { label: 'ホーム', path: '/dashboard' },
            { label: '共創パートナー募集一覧' },
          ]}
        />

        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">共創パートナー募集一覧</h1>
          <RadioButtonGroup buttons={sortButtons} />
        </div>

        {/* 募集一覧グリッド */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
          {isLoading && recruitments.length === 0 ? (
            <div className="flex justify-center py-20 col-span-full">
              <LoadingSpinner />
            </div>
          ) : recruitments.length === 0 ? (
            <div className="col-span-full">
              <div className="text-center py-8 text-main-darkgray">
                パートナー募集がありません。
              </div>
            </div>
          ) : (
            <>
              {recruitments.map((rec, index) => (
                <PartnerRecruitmentCard
                  key={`${rec.id}-${index}`}
                  recruitment={rec}
                  initialized={!isLoading}
                  onClick={() => navigate(`/recruitment/${rec.id}`)}
                />
              ))}
            </>
          )}

          {recruitments.length > 0 && hasMore && LoadingElement}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}

export default RecruitmentPage
